import { MotifButton, MotifCard, MotifCardBody, MotifChip, MotifChipGroup, MotifFileUploader, MotifFileUploaderItem, MotifFormField, MotifIcon } from '@ey-xd/motif-react';
import React, { useCallback, useState } from 'react'
import { useDispatch } from 'react-redux';
import iconSvg from "../../assets/icons/icon.svg.json";

const ConversationFileSelect = (props: any) => {
    const { content, enabledToAnswer } = props;
    const dispatch = useDispatch();
    const [file, setFile] = useState<any>(undefined);
    const submitFile = () => {
        dispatch({ type: "CONVERSATION_MESSAGE_SEND", payload: { file: file[0] } })
    }
    const onDrop = useCallback((acceptedFiles) => {
        setFile(acceptedFiles)
      }, []);
    const renderFileSelect = useCallback(() => {
        const { options } = content;
        return (
            <MotifFormField onChange={event => {

                setFile(event.target.files)
            }} >
                <MotifFileUploader
                    onDrop={onDrop as any}
                    disabled={!enabledToAnswer}
                    label="Click to upload or drag and drop"
                    reactive
                >
                    <>
                        {({ getRootProps, getInputProps }) => (
                            <section>
                                <div {...getRootProps()}>
                                    <input {...getInputProps()} />
                                    <p>Drag 'n' drop some files here, or click to select files</p>
                                </div>
                            </section>
                        )}
                    </>
                    {file !== undefined && (
                        <MotifFileUploaderItem
                            fileName={file[0]?.path}
                            id={1}
                            onRemove={() => {
                                setFile(undefined)
                            }}
                            removable
                        />
                    )}
                </MotifFileUploader>
            </MotifFormField>
        )
    }, [file, enabledToAnswer])
    return (
        <MotifCard className="!w-full">
            <MotifCardBody>
                <div className="flex justify-between gap-2 text">
                    <p className="text-lg font-bold">
                        {content.title}
                    </p>
                    {
                        content.file && (
                            <p onClick={() => { window.open(content.file.downloadUrl, "_self"); }} className="flex justify-center items-center gap-2 cursor-pointer !text-sm">
                                <MotifIcon src={iconSvg["file-icon"]} className="w-3 font-[400]" title='Harrow-right' /> {content.file.title}
                            </p>
                        )
                    }
                </div>
                <hr className='my-4' style={{ opacity: "0.1" }} />
                {renderFileSelect()}
                <div className="flex justify-end">
                    <MotifButton
                        size="small"
                        endIcon={null}
                        onClick={submitFile}
                        startIcon={null}
                        disabled={file === undefined || !enabledToAnswer}
                    >
                        Submit
                    </MotifButton>
                </div>
            </MotifCardBody>
        </MotifCard>
    )
}

export default ConversationFileSelect